import { Component, OnInit } from '@angular/core';
import { Appraisal } from '../../../shared/model/appraisal';
import { ActivatedRoute } from '@angular/router';
import { AppraisalService } from '../../service/appraisal.service';
import { AppraisalTestService } from '../../service/appraisal-test.service';
import { Equipment } from '../../../shared/model/equipment';
import { EquipmentModel } from '../../../shared/model/equipment-model';
import { SimCard } from '../../../shared/model/sim-card';
import { Access } from '../../../shared/model/access';
import { TelecomProvider } from '../../../shared/model/telecom-provider';
import * as moment from 'moment';
import { ToastService } from '../../../shared/service/toast.service';

declare var Materialize: any;

@Component({
  selector: 'tx-appraisal-visualize',
  templateUrl: './appraisal-visualize.component.html',
  styleUrls: ['./appraisal-visualize.component.css']
})
export class AppraisalVisualizeComponent implements OnInit {
  appraisal: Appraisal;
  appraisalTestsItems: any;
  unavailable = 'Indisponível';

  constructor(private _route: ActivatedRoute,
              private _appraisalService: AppraisalService,
              private _appraisalTestService: AppraisalTestService,
              private _toastService: ToastService) {
    this.setUpObservers();
    this.setEmptyEntities();
    this.findAppraisal();
  }

  ngOnInit() {
  }

  findAppraisal() {
    this._route.params.subscribe(params => {
      if (params['id']) {
        const appraisalId = +params['id'];
        this._appraisalService.findById(appraisalId);
        this._appraisalTestService.findAsMap(appraisalId);
      }
    });
  }

  setUpObservers() {
    this._appraisalService.find$
      .filter(appraisal => appraisal instanceof Appraisal)
      .subscribe(appraisal => this.appraisal = appraisal);

    this._appraisalService.error$
      .subscribe(error => this.showMessage(error.text));

    this._appraisalTestService.find$
      .subscribe(testItems => this.appraisalTestsItems = testItems);
  }

  downloadAppraisal() {
    this._appraisalService.downloadAppraisal(this.appraisal);
  }

  setEmptyEntities() {
    this.appraisal = new Appraisal();
    this.appraisal.files = [];
    this.appraisal.equipment = new Equipment();
    this.appraisal.equipment.equipmentModel = new EquipmentModel();
    this.appraisal.equipment.equipmentModel.equipmentManufacturer = {};
    this.appraisal.equipment.equipmentModel.equipmentManufacturer.equipmentType = {};
    this.appraisal.equipment.simCard = new SimCard();
    this.appraisal.equipment.simCard.access = new Access();
    this.appraisal.equipment.simCard.telecomProvider = new TelecomProvider();
  }

  formatDate(date) {
    if (date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    }
    return null;
  }

  getObjectKeys(object) {
    if (object) {
      return Object.keys(object);
    }
    return [];
  }

  showMessage(message) {
    this._toastService.showMessage(message, 4000);
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/appraisal/component/appraisal-visualize/appraisal-visualize.component.ts